import classNames from 'classnames';
import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import { useIsMobile } from '../../helpers/hooks';
import { Icon } from '../icon/Icon';
import { SidebarProps } from './models';
import selected from '../../assets/selected.svg';

import * as styles from './styles';

const Sidebar = React.memo(
  forwardRef(
    (
      {
        className: _className,
        children,
        title,
        onSelectedChange,
        selectedIndex = -1,
        defaultOpenState = false,
      }: SidebarProps,
      ref
    ) => {
      const [open, setOpen] = useState(defaultOpenState);
      const isMobile = useIsMobile();

      const onItemClick = useCallback(
        (index: number) => {
          onSelectedChange(index);
        },
        [onSelectedChange]
      );

      useImperativeHandle(ref, () => ({
        setOpen: (state) => {
          setOpen(state);
        },
      }));

      const className = classNames(_className, { open: open });
      return (
        <nav className={className}>
          {title && <h2 className="title">{title}</h2>}

          <div className="nav-items">
            {React.Children.map(children, (child, index) => (
              <li
                onClick={() => onItemClick(index)}
                key={index}
                style={{ '--animation-order': index } as React.CSSProperties}
                className={classNames('sidebar-item-container', { selected: index === selectedIndex })}
              >
                <span className="sidebar-item">
                  {child}

                  {isMobile && index === selectedIndex ? <Icon className="sidebar-item-icon" src={selected} /> : null}
                </span>
              </li>
            ))}
          </div>
        </nav>
      );
    }
  )
);

const StyledSidebar = styled(Sidebar)`
  ${styles.Sidebar}
`;
export default StyledSidebar;
